import React from "react";
import { Button } from "..";
import { colors, fonts, glyphs} from "../../Styles";
import { ButtonTypes } from "../../Definitions";

interface FilterSection {
  label: string;
  state: boolean;
  toggle: React.Dispatch<React.SetStateAction<boolean>>;
  content: JSX.Element;
}

type filterPopupProps = {
  filterSections: FilterSection[]
  displayFilters: boolean
  setDisplayFilters: React.Dispatch<React.SetStateAction<boolean>>
  onReset: () => void
} 

export default function FilterPopup({filterSections, displayFilters, setDisplayFilters, onReset}:filterPopupProps) {
  return (
    <div style={{ position: "relative", zIndex: 9 }}>
      <Button 
        content="Filter" 
        onClick={() => setDisplayFilters(!displayFilters)} 
        buttonType={ButtonTypes.tableButton} 
        startEnhancer={glyphs.FilterParameter({})}
      />
      {displayFilters && (
        <div 
          style={{ 
            position: "absolute", top: "55px", left: "50%", transform: "translateX(-50%)", zIndex: 99, 
            backgroundColor: colors.greyDarkPrimary, borderRadius: "10px", padding: "10px", 
            border: `5px solid ${colors.greyDarkPrimary}`, width: "180px"
          }}
        >
          <Button 
            content="Reset Filters" 
            onClick={onReset} 
            buttonType={ButtonTypes.textButton} 
          />
          <div style={{ width: "100%", height: "2px", backgroundColor: colors.greyDarkSecondary, margin: "10px 0" }} />
  
          <div 
            style={{ 
              display: "flex", flexDirection: "column", gap: "20px", maxHeight: "250px", overflowY: "scroll", 
              scrollbarWidth: "thin", scrollbarColor: `${colors.greyDarkSecondary} ${colors.transparent}` 
            }}
          >
            {filterSections.map(({ label, state, toggle, content }, index) => (
              <div key={label}>
                <div 
                  style={{ display: "flex", gap: "10px", cursor: "pointer" }} 
                  onClick={() => toggle(!state)}
                >
                  <p style={{ ...fonts.header, ...fonts.fontSize4, color: colors.greyLightTertiary, marginBottom: "5px" }}>
                    {label}
                  </p>
                  <glyphs.Arrow transparency={state ? 1 : 0.3} rotate={state ? 90 : 0} size="15px" />
                </div>
                {state && (
                  <>
                    <div>{content}</div>
                    {index < filterSections.length - 1 && (
                      <div style={{ height: "2px", width: "90%", backgroundColor: colors.greyDarkSecondary, marginTop: "5px" }} />
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
